export default {
  'user.details.profile': '个人资料',
  'user.details.copy': '复制',
  'user.details.copy.success': '复制成功',
  'user.details.loadFailed': '用户信息加载失败',

  'user.details.account': '会员账号',
  'user.details.memberId': '会员ID',
  'user.details.email': '邮箱',
  'user.details.registerType': '注册方式',
  'user.details.registerType.phone': '手机号',
  'user.details.registerType.email': '邮箱',
  'user.details.region': '所属地区',
  'user.details.merchant': '所属商户',

  'user.details.status': '账号状态',
  'user.details.status.formal': '正常',

  'user.details.parentAgent': '上级代理',
  'user.details.sameParentCount': '同上级会员人数',

  'user.details.realName': '真实姓名',
  'user.details.sameNameCount': '同名会员人数',

  'user.details.vipLevel': 'VIP等级',
  'user.details.memberLevel': '会员层级',
  'user.details.defaultLevel': '默认层级',

  'user.details.balance': '账户余额',
  'user.details.balance.available': '可用',
  'user.details.balance.yuebao': '余额宝',
  'user.details.balance.frozen': '冻结',
  'user.details.balance.cashWallet': '现金',
  'user.details.balance.bonusWallet': '奖金',

  'user.details.dpTodayTotal': '今日/累计充值',
  'user.details.wdTodayTotal': '今日/累计提现',
  'user.details.validBetTodayTotal': '今日/累计有效投注',
  'user.details.winlossTodayTotal': '今日/累计输赢',
  'user.details.promoTodayTotal': '今日/累计活动优惠',
  'user.details.commissionTodayTotal': '今日/累计结算佣金',

  'user.details.withdrawAccount': '提现账号',
  'user.details.lastLogin': '最后登录',
  'user.details.registerIp': '注册IP',
  'user.details.loginType': '登录类型',
  'user.details.registerChannel': '注册渠道',
  'user.details.verifyMethod': '验证方式',

  'user.details.addBlacklist': '加入黑名单',
  'user.details.disableEnableAccountTitle': '${status}账号',
  'user.details.disableAccount': '禁用账号',
  'user.details.enableAccount': '启用账号',
  'user.details.disableEnableAccountContant': '你确定要${status}这个账号吗？',
  'user.details.enable': '启用',
  'user.details.disable': '禁用',
  
  'user.details.resetPassWordTitle': '重置用户密码',
  'user.details.resetPassWordContant': '是否确定重置该用的的密码：', 
  
  'user.details.userInviteTreeTitle': '代理树',

  'user.details.sameNameUserListTitle': '同名用户',



  'user.details.forbidBet': '禁止投注',
  'user.details.kick': '踢出大厅',
  'user.details.changePassword': '修改密码',
  'user.details.changeFundPassword': '修改资金密码',
  'user.details.resetFundPassword': '重置资金密码',
  'user.details.agentLine': '代理拉线',
  'user.details.inviteTree': '代理树',

  'user.details.changeLevel': '修改层级',

  'user.details.manualDp': '人工提存',
  'user.details.fundDetail': '资金明细',
  'user.details.dpRecords': '充值记录',
  'user.details.wdRecords': '提现记录',
  'user.details.auditDetail': '稽核详情',
  'user.details.betRecords': '投注记录',
  'user.details.winlossOverview': '输赢总览',
  'user.details.winlossStats': '输赢统计',
  'user.details.promoRecords': '优惠记录',

  'user.details.sameIpLoginCount': '同IP登录人数',
  'user.details.sameIpRegisterCount': '同IP注册人数',

  'user.details.phone': '手机',
  'user.details.changePhone': '修改Whatsapp',
  'user.details.changeEmail': '修改邮箱',
  'user.details.unbindTelegram': '解绑Telegram',

  'common.details.operationSuccess': '操作成功!!!',
  'common.details.operationFailed': '操作失败,请重试！',

  'common.normal': '正常',
  'common.Enable': '正常',
  'common.Disable': '禁用',
  'common.refresh': '刷新',
  'common.unbound': '未绑定',
  'common.remark': '备注',
  'common.edit': '修改',

};
